import { event, utils } from '../../Foundation';

export class PAConfigurator {
    /**
    * PAConfigurator
    * Control a PA Configurator
    * @param {HTMLElement} element - Configurator
    */
    constructor (element) {
        // Name
        element.PAConfigurator = this;
        this.el = element;

        // References
        this.qtyTxtBox = element.querySelector('#QtyTextBox');
        this.oStockQtyMax = element.querySelector('#StockQuantityHiddenField');
        this.oPatientQtyMax = element.querySelector('#PatientQuantityHiddenField');
        this.oConsignmentQtyMax = element.querySelector('#ConsignmentQuantityHiddenField');
        this.minus = element.querySelector('.number-input__button--minus');
        this.plus = element.querySelector('.number-input__button--plus');

       
        // Properites
        this._props = {
            manager: window.Sys.WebForms.PageRequestManager.getInstance(),
            addToCart: this.el.querySelector('.btn-primary')
        }

        // Onload
        this.oLoad = true;
        this._togglPanel();
        this._extendWarranty();
        this._alignTopConfigurator();

        // Updatepanel - callback event attachments
        if(typeof this._props.manager !== "undefined" && this._props.manager !== null) {
            this._props.manager.add_endRequest((sender, e) => {
                this._togglPanel();
                this._extendWarranty();

                // actions
                this._scrollToTarget(sender);
            });
        }
    }

    /**
     * _togglPanel
     * Toggl patientinfo based on ordermode selection
     * @type Private
     */
    _togglPanel () {
        const
            arrOrderModes = Array.from(this.el.querySelectorAll('#configure__ordertypeandquatiantity input[type="radio"]')),
            clickHandler = () => {
                let selectedOrderMode = 0;
                let orderMode = 0;

                const oPatientInfoList = this.el.querySelectorAll('#ConfigurePatientInformationPanel, .CustomInsertInformationPanel');
                
                // Find selected mode
                arrOrderModes.forEach(x => {
                    if(x.checked) {
                        selectedOrderMode = parseInt(x.parentElement.dataset.showpatientBox);
                        orderMode = parseInt(x.parentElement.dataset.orderMode);
                    }
                });

                for(const oPatientInfo of oPatientInfoList) {
                    if(selectedOrderMode) {
                        oPatientInfo.classList.remove('is-hidden');
                        //update quantity for patient
                    } else {
                        oPatientInfo.classList.add('is-hidden');
                    }
                }

                if (orderMode == 0) {

                    //for stock
                    this.qtyTxtBox.setAttribute('max', this.oStockQtyMax.value);
                    

                }
                else if (orderMode == 1) {
                    //for Patient
                    this.qtyTxtBox.setAttribute('max', this.oPatientQtyMax.value);
                    
                }
                else {
                    //for consignment
                    this.qtyTxtBox.setAttribute('max', this.oConsignmentQtyMax.value);
                    
                }

                if (!this.oLoad) {

                    this.qtyTxtBox.value = "1";
                    this.plus.classList.remove('is-disabled');
                    this.minus.classList.add('is-disabled');
                }
                else {
                    this.oLoad = false;
                }
               

            };

        clickHandler();

        // Event handling
        arrOrderModes.forEach(x => x.addEventListener('change', clickHandler.bind(this)));
    }

    /**
     * extendWarranty
     * @description Work-around for handling dropdown-control to avoid it being disabled as part of the accessory-component
     * @type Private
     */
    _extendWarranty () {
        const oWarranty = this.el.querySelector('.configurator__accessory-warranty select');
        if(oWarranty === null) { return false; }

        oWarranty.classList.remove('is-disabled');
        event.emit(oWarranty, 'reflow');
    }

    /**
     * scrollToTarget
     * Scroll to a predefined area of the page based on feedback
     * @type Private
     * @param {Object} panel - Updatepanel
     */
    _scrollToTarget (panel) {
        if (panel == null || panel._postBackSettings.panelsToUpdate == null || !panel._postBackSettings.sourceElement.classList.contains('btn-primary')) {
            return false;
        }

        const alerts = Array.from(this.el.querySelectorAll('.configurator__alerts .alert'));
        if(alerts.length) {
            window.scrollTo(0, alerts[0].offsetTop);
        }
    }

    /**
     * clearPostBackWidthValidation
     * Emit and clear postback validation with backend
     * @type {Private}
     */
    _clearPostBackWithValidation() {
        const
            eventTarget = document.getElementById('__EVENTTARGET'),
            eventArgument = document.getElementById('__EVENTARGUMENT');

        eventTarget.value = eventArgument.value = '';
        Sys.WebForms.PageRequestManager.getInstance().remove_endRequest(clearPostBackWithValidation);
    }

    /**
     * doPostBackWidthValidation
     * @param {String} eventTargetClientId - Client target id
     * @param {String} eventArgument - Argument to parse
     * @type {Private}
     */
    _doPostBackWithValidation(eventTargetClientId, eventArgument) {
        Sys.WebForms.PageRequestManager.getInstance().add_endRequest(clearPostBackWithValidation);
        __doPostBack(eventTargetClientId, eventArgument);
    }

    _alignTopConfigurator() {
        const topHeader = this.el.querySelectorAll('.configurator__title');
        if(!topHeader) return;
        utils.alignHeight(topHeader[0], topHeader[1]);
    }
}
